import {settings} from "@/lib/settings"

class GoogleAnalytics {
    constructor() {
        this.GTAG = null
        window.dataLayer = window.dataLayer || []
        window.gtag = function () { window.dataLayer.push(arguments); }
    }

    init() {
        this.GTAG = settings.GOOGLE_ANALYTICS_TAG

        if (this.GTAG) {
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${this.GTAG}`;
            document.head.appendChild(script);

            script.onload = () => {
                window.gtag("js", new Date());
                window.gtag("config", this.GTAG)
            };
        } else {
            console.error('Google Analytics tag is missing!');
        }
    }

    trackingEvent(eventName, eventContent) {
        if (this.GTAG && window.gtag) {
            window.gtag('event', eventName, eventContent);
        }
    }
}

export const googleAnalytics = new GoogleAnalytics();